import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { ButtonClose } from "style/components/pc";
import ButtonCloseDark from "images/pc/button-close-invert.svg";

interface Props {
  popupType?: string;
  title: string;
  children: JSX.Element;
  onOk: any;
  isLarge?: boolean;
  coveredStyle?: boolean;
}

const PopupFull: React.FunctionComponent<Props> = ({
  popupType,
  title,
  children,
  onOk,
  isLarge,
  coveredStyle
}) => {
  useEffect(() => {
    document.body.classList.add("scrollHidden");
    return () => {
      document.body.classList.remove("scrollHidden");
    };
  });

  return (
    <Modal className={`${isLarge ? "large" : "default"}`}>
      <div className="modal">
        {popupType !== "notice" && (
          <ButtonClose
            type="button"
            onClick={onOk}
            className="close"
            aria-label="팝업 닫기"
          />
        )}
        <div className={`modalInner ${coveredStyle ? "covered" : ""}`}>
          {!coveredStyle && (
            <header className="header">
              <h3>{title}</h3>
            </header>
          )}
          <div className="body">{children}</div>
        </div>
      </div>
    </Modal>
  );
};

const Modal = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);

  .close {
    position: absolute;
    right: -50px;
    transition: right 0.2s ease-in-out;
  }

  &:not(.large) {
    .close {
      @media (max-width: 600px) {
        top: 13px;
        right: 10px;
        background-image: url(${ButtonCloseDark});
      }
    }
  }

  .modal {
    position: relative;
    width: 480px;
    border-radius: ${props => props.theme.radius};
    background-color: ${props => props.theme.colors.white};
  }

  .modalInner {
    overflow-y: auto;
    padding: 50px 50px 0;
    white-space: pre-line;

    &.covered {
      padding: 0;
    }
  }

  .header {
    margin-bottom: 30px;
    font-size: ${props => props.theme.popup.sizeHeader};
    font-weight: ${props => props.theme.weight.extraBold};
  }

  .body {
    padding-bottom: 50px;
    color: ${props => props.theme.popup.colorDesc};
    font-size: ${props => props.theme.popup.sizeDesc};
    line-height: 1.67;
    letter-spacing: -0.3px;
  }

  &.default {
    display: flex;
    align-items: center;
    justify-content: center;

    .modalInner {
      min-height: 416px;
      max-height: 640px;
    }
  }

  &.large {
    padding-top: 100px;

    .modal {
      margin: 0 auto;
      width: 920px;
      height: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      @media (max-width: 1024px) {
        width: 100%;
      }
    }

    .modalInner {
      height: 100%;
    }

    .header {
      margin-bottom: 19px;
    }

    .close {
      @media (max-width: 1024px) {
        top: -40px;
        right: 0;
      }
    }
  }
`;

export default PopupFull;
